/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
  play: {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M8 5.14v14l11-7-11-7z" _fill="#000"/>'
  }
});
